/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import React,{Component} from "react";
import { ReactComponent as Logo } from "../icons/capella.svg";
import {YoLog} from "yospace-ui-components";
import {YOSPACE_EVENT_STREAM_STATUS_URL} from "../common/Urls";
import PropTypes, {number} from "prop-types";
import ActiveEncoderStatusViewStyles from "./ActiveEncoderStatusViewStyles";
import UserService from "../common/UserService";

export default class ActiveEncoderStatusView extends Component {
    constructor(props) {
        super(props);

        this.state = { numEncoders: 0 };
        this.interval = null;
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            const headers = new Headers();
            headers.append("Authorization", `Bearer ${UserService.getToken()}`);

            fetch(YOSPACE_EVENT_STREAM_STATUS_URL, {
                headers: headers
            }).then(response => {
                response.json().then(data => {
                    let numEncoders = data.summary?.bcm?.running_encoders;
                    if (numEncoders !== undefined) {
                        this.setState({numEncoders: numEncoders});
                    }
                }).catch(e => {
                    YoLog.e("Error retrieving data from " + YOSPACE_EVENT_STREAM_STATUS_URL + ": " + e.message);
                });
            }).catch(e => {
                YoLog.e("Error retrieving data from " + YOSPACE_EVENT_STREAM_STATUS_URL + ": " + e.message);
            });
        }, 5000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    render() {
        return (
            <div style = { ActiveEncoderStatusViewStyles.getMain() } >
                <div style = { ActiveEncoderStatusViewStyles.getLogoContainer()} >
                    <Logo />
                </div>
                <div  >
                    Active Encoder Instances
                </div>
                <div style = { ActiveEncoderStatusViewStyles.getEncodersOuterContainer() } >
                    <div style = { ActiveEncoderStatusViewStyles.getEncodersInnerContainer() } >
                        { this.state.numEncoders }
                    </div>
                </div>
            </div>
        )
    }
}

ActiveEncoderStatusView.propTypes = {
    data: PropTypes.shape({
        summary: PropTypes.shape({
            bcm: PropTypes.shape({
                running_encoders: number
            })
        })
    })
}
